import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { BarOwnerDataProvider } from "../../context/BarOwnerDataContext";
import OnboardingRoute from "../../components/common/OnboardingRoute";
import Onboarding from "./pages/Onboarding";
import BarOwnerDashboard from "./pages/BarOwnerDashboard";
import Calendar from "./pages/Calendar";
import Artists from "./pages/Artists";
import Financials from "./pages/Financials";
import Management from "./pages/Management";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import Messages from "./pages/Messages";

const BarOwnerRoutes = () => {
  return (
    <BarOwnerDataProvider>
      <Routes>
      {/* Onboarding - Protected: redirects to dashboard if already completed */}
      <Route
        path="/onboarding"
        element={
          <OnboardingRoute>
            <Onboarding />
          </OnboardingRoute>
        }
      />

      {/* Protected routes - require onboarding completion */}
      {/* Overview */}
      <Route
        path="/"
        element={
          <OnboardingRoute>
            <BarOwnerDashboard />
          </OnboardingRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <OnboardingRoute>
            <BarOwnerDashboard />
          </OnboardingRoute>
        }
      />

      {/* Music */}
      <Route
        path="/calendar"
        element={
          <OnboardingRoute>
            <Calendar />
          </OnboardingRoute>
        }
      />
      <Route
        path="/artists"
        element={
          <OnboardingRoute>
            <Artists />
          </OnboardingRoute>
        }
      />
      <Route
        path="/financials"
        element={
          <OnboardingRoute>
            <Financials />
          </OnboardingRoute>
        }
      />

      {/* House Keeping */}
      <Route
        path="/management"
        element={
          <OnboardingRoute>
            <Management />
          </OnboardingRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <OnboardingRoute>
            <Settings />
          </OnboardingRoute>
        }
      />

      {/* Communication */}
      <Route
        path="/notifications"
        element={
          <OnboardingRoute>
            <Notifications />
          </OnboardingRoute>
        }
      />
      <Route
        path="/messages"
        element={
          <OnboardingRoute>
            <Messages />
          </OnboardingRoute>
        }
      />

      {/* Redirect unknown routes to dashboard */}
      <Route path="*" element={<Navigate to="/bar-owner" replace />} />
      </Routes>
    </BarOwnerDataProvider>
  );
};

export default BarOwnerRoutes;
